define('modules/lists/modals/views/edit.contact.view',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    'semantic',
    'modules/base/models/identity.model',
    'modules/base/models/identity.profile.model',
    'modules/base/modals/views/modal.view',
    "text!modules/lists/modals/templates/edit.contact.template.html"
], function(
    Prospector,
    $, _,Backbone, semantic,
    IdentityModel,
    IdentityProfileModel,
    ModalView,
    Template
){
    var EditContactView = ModalView.extend({
        minimumList: 0,
        template: _.template(Template),
        initialize: function(options) {
            this.debugName = 'move list view';
            if(options.model != undefined && options.model.attributes != undefined){
                this.identityModel =  new IdentityModel(options.model.attributes);
            } else if(options.model != undefined){
                this.identityModel = new IdentityModel(options.model);
            }
            this.name = options.name;
            if(options.minimumList != undefined){
                this.minimumList = options.minimumList;
            }
            ModalView.prototype.initialize.call(this, options);
            Prospector.on("refreshListName", this.refreshListDropDown, this);
            Prospector.on("refreshSubviewDropDownList", this.refreshListDropDown, this);
        },
        buildModel:function(){
            this.model = new IdentityProfileModel({
                identityType: this.identityModel.get('identityType'),
               source:{
                  sourceId: this.identityModel.get('source').sourceId,
                   refId: this.identityModel.get('source').refId
               }
            });
            this.fetchModel();
        },
        fetchModel:function(){
            this.cleanMySubviews();
            this.model.once('sync', this.procModel, this);
            if(this.abortable){
                if(this.currXHR != undefined && this.currXHR.readyState > 0 && this.currXHR.readyState < 4){
                    this.currXHR.abort();
                }
            }
            this.currXHR = this.model.fetch();
        },
        refreshListDropDown: function() {
            Prospector.trigger("closeTopDrawer");
            this.procResponse();
        },
        procResponse:function(){
            this.$('.ripple').hide();
            this.$('.mainBtn').css('display', 'inline-block');
            this.$('.modal-body').show();
            this.$('.modal-title').html('Save ' + this.model.getName() + ' to a List');
            if(window.entitlements.get('settings').allowSetContactType){
                this.$('.hasContactTypePriv').show();
                var stuff = this.$('.contactType .btn-default');
                var switchVal = "";
                if(this.model.has('contactType')){
                    switchVal = this.model.get('contactType');
                }
                switch(switchVal.toLowerCase()){
                    case 'client':{
                        $(stuff[2]).addClass('active');
                        break;
                    }
                    case 'prospect':{
                        $(stuff[1]).addClass('active');
                        break;
                    }
                    default:{
                        $(stuff[0]).addClass('active');
                        break;
                    }
                }
            } else {
                this.$('.hasContactTypePriv').remove();
            }

            this.$('.hasLists').show();
            var needsListName = this.name != undefined;
            var selectedValues = [];
            window.user.fetch();
            var iLists = this.model.get('lists');
            _.each(window.utils.getInternalLists(), function(list){
                var matchedListed = _.any(iLists, function(iList){
                    return iList.source.refId == list.source.refId;
                }, this);
                if(list.name == this.name){
                    selectedValues.push(list.source.refId.toString());
                    needsListName = false;
                } else if(matchedListed){
                    selectedValues.push(list.source.refId.toString());
                }
                this.$('.ui.dropdown .menu').append('<div class="item" data-source="1" data-value="' + list.source.refId+ '">' +list.name+ '</div>');
            }, this);
            if(needsListName){
                this.$('.ui.dropdown .menu').append('<div class="item" data-source="1" data-value="' + this.name+ '">' + this.name+ '</div>');
                selectedValues.push(this.name);
            }

            var that = this;
            this.$('.ui.dropdown').dropdown({
                allowAdditions: true,
                fullTextSearch: true,
                forceSelection: false,
                onHide:function(){
                    $(that.$('.ui.dropdown input')[1]).val("");
                }
            });
            window.setTimeout($.proxy(function(){
                this.$('.ui.dropdown').dropdown('set selected',selectedValues);
            }, this), 300);
        },
        getSelectedLists:function(){
            var lists = this.$('.ui.dropdown').dropdown('get values');
            if(lists.constructor !== Array){
                lists = [];
            }
            var a = this.$('input.search').val();
            if(a!= undefined && a != ""){
                lists.push(a);
            }
            return lists;
        },
        procMainBtn:function(e){
            var lists = this.getSelectedLists();
            if(this.minimumList != 0 && (lists == undefined || lists.length == undefined || lists.length < this.minimumList)){
                this.removeMainBtnLoader();
                if(this.minimumList == 1){
                    this.errOut('You must enter at least one list.');
                } else {
                    this.errOut('You must enter at least ' + this.minimumList + ' lists.');
                }
            } else {
                this.passedNumListCheck();
            }
        },
        passedNumListCheck:function(){
            this.buildLists();
            this.configModel();
        },
        configModel:function(e){
            if(window.entitlements.get('settings').allowSetContactType){
                var stuff = this.$('.contactType .btn-default.active input');
                switch(stuff.prop('value').toLowerCase()){
                    case 'client':{
                        this.identityModel.set({
                            contactType: 'client'
                        });
                        break;
                    }
                    case 'prospect':{
                        this.identityModel.set({
                            contactType: 'prospect'
                        });
                        break;
                    }
                    default:{
                        this.identityModel.set({
                            contactType: 'lead'
                        });
                        break;
                    }
                }
            } else {
                this.identityModel.set({
                    contactType: 'contact'
                });
            }
            this.createLists();

        },
        buildLists:function(){
            var lists = this.getSelectedLists();
            this.listArr = new Array();
            this.createListArr = new Array();
            _.each(lists, function(list){
                var found = false;
                _.each(window.utils.getInternalLists(), function(mList){
                    if(list == mList.source.refId.toString() &&  mList.source.sourceId == 1){
                        this.listArr.push(mList);
                        found = true;
                    }
                },this);
                if(!found){
                    this.createListArr.push(list);
                }
            }, this);
        },
        createLists:function(){
            if(this.createListArr.length > 0){
                this.createListAsync();
            } else {
                this.identityModel.set({
                    lists: this.listArr
                });
                this.identityModel.once('sync', this.procCreateLists, this);
                this.identityModel.save();
            }
        },
        procCreateLists:function(){
            if(this.identityModel.has("error")){
                this.errOut(this.identityModel.get("error").message);
                this.removeMainBtnLoader();
            } else {
                this.mainBtnResponse();
            }
        },
        procMainBtnResponse:function(){
            var that = this;
            Prospector.trigger("clearToast");
            Prospector.trigger('refreshLists');

            that.closeModal();
        },
        createListAsync:function(){
            var victim = this.createListArr.shift();
            var that = this;
            require(['modules/base/models/list.model'], function(listModel){
                that.listModel = new listModel({
                    "name": victim,
                    "isSharedList": false
                });
                that.listModel.once('sync', that.procCreateListAsync, that);
                that.listModel.creating = true;
                that.listModel.save();
            });

        },
        procCreateListAsync:function(){
            if(this.listModel.has("error").message){
                this.errOut(this.listModel.get("error").message);
            } else {
                this.listArr.push({
                    name: this.listModel.get("name"),
                    isSharedList: this.listModel.get("isSharedList"),
                    source: {
                        sourceId: 1,
                        refId: this.listModel.get("id").toString()
                    }
                });
                window.user.attributes.lists.push({
                    name: this.listModel.get("name"),
                    isSharedList: this.listModel.get("isSharedList"),
                    totalIdentities: this.listModel.get("totalIdentities"),
                    following: this.listModel.get("following"),
                    source: {
                        sourceId: 1,
                        refId: this.listModel.get("id").toString()
                    }
                });
                if(this.createListArr.length > 0){
                    this.createListAsync();
                }else{
                    this.createLists();
                }
            }
        }

    });
    return EditContactView;
});
